// US locale: es
export default {
  "login.title": "MedConcil",
  "login.subtitle": "Apoyo a decisiones clínicas",
  "login.welcome": "Bienvenido",
  "login.signInMessage": "Sign in to access your MedConcil workspace",
  "login.continueWithGoogle": "Continue with Google",
  "login.terms": "By signing in, you agree to our Terms of Service and Privacy Policy",
  "login.feature1.title": "Multi-Model Consensus",
  "login.feature1.desc": "Query GPT and Op simultaneously",
  "login.feature2.title": "Enterprise PII Protection",
  "login.feature2.desc": "Automatic redaction of sensitive data before LLM processing",
  "login.feature3.title": "Team Collaboration",
  "login.feature3.desc": "Full audit logging and cost governance for your organization",
  "login.signInDesc": "Inicie sesión para acceder al consilium clínico",
  "login.signInGoogle": "Iniciar sesión con Google",
  "login.signingIn": "Iniciando sesión...",
  "login.signInEmail": "Iniciar sesión con Email",
  "login.password": "Contraseña",
  "login.register": "Crear cuenta",
  "login.noAccount": "¿No tiene cuenta?",
  "login.createAccount": "Crear una",
  "login.hasAccount": "¿Ya tiene cuenta?",
  "login.signIn": "Iniciar sesión",
  "login.or": "o",
  "login.checkEmail": "Check your email for the confirmation link",
  "login.error": "Sign in failed",
  "login.oauthNotConfigured": "This sign-in method is not available in this deployment.",
  "login.forgotPassword": "¿Olvidó su contraseña?",
  "login.rememberMe": "Recordarme",
  "login.emailVerified": "Email verified. Please sign in.",
  "login.resetSent": "Password reset link sent to your email",
  "login.enterEmailFirst": "Enter your email first",
  "login.gdpr": "GDPR Compliant",
  "login.pii": "PII Redacted",
  "login.footer": "Clinical Decision Support - Not a Replacement for Physician Judgment",
  "legal.termsNoticeSignin": "By signing in, you agree to our",
  "legal.termsNoticeSignup": "By creating an account, you agree to our",
  "legal.privacyPolicy": "Política de privacidad",
  "legal.termsOfUse": "Terms of Use",
  "legal.cookiePolicy": "Cookie Policy",
  "legal.and": "and",
  "legal.redirecting": "Redirecting to the legal page…",
  "nav.voice": "Voice",
  "nav.query": "Query",
  "nav.history": "History",
  "nav.admin": "Admin",
  "nav.adminSection": "Admin",
  "nav.clinicalSupport": "Clinical Decision Support",
  "nav.account": "Account",
  "nav.settings": "Settings",
  "nav.signOut": "Sign out",
  "nav.activeCouncil": "Active Council",
  "nav.plan": "plan",
  "voice.pageTitle": "Voice Recording",
  "voice.readyTitle": "Record an appointment",
  "voice.readyDesc": "Press to start recording a conversation with the patient",
  "voice.consent": "Make sure the patient has given consent to recording",
  "voice.recordingLabel": "Recording in progress",
  "voice.transcribing": "Recognizing speech...",
  "voice.reviewLabel": "Conversation transcript â edit if needed",
  "voice.send": "Send to Consilium",
  "voice.reRecord": "Record again",
  "voice.noKey": "Groq API key not set",
  "voice.noKeyTitle": "Groq API key not set",
  "voice.noKeyDesc": "Add the key in the Admin section for speech recognition to work",
  "voice.goToAdmin": "Go to Admin",
  "voice.permDenied": "Microphone access denied. Check browser permissions.",
  "voice.noSupport": "Browser does not support audio recording",
  "admin.groqKeyLabel": "Groq API Key (for speech recognition)",
  "admin.groqKeyDesc": "Key for speech recognition via Groq Whisper. Stored locally in browser.",
  "admin.groqPersonalLabel": "Personal key (this browser only)",
  "admin.groqServerLabel": "Default key (for all users)",
  "admin.groqServerActive": "Active for all users",
  "admin.groqServerKeySet": "Server key is configured",
  "admin.groqServerKeyNotSet": "No server key set",
  "admin.groqServerSaved": "Server key saved",
  "admin.groqServerError": "Failed to save server key",
  "admin.groqKeySaved": "Groq API key saved",
  "admin.groqKeyCleared": "Groq API key cleared",
  "admin.saved": "Saved",
  "admin.save": "Save",
  "query.voiceCardTitle": "Record an appointment",
  "query.voiceCardDesc": "Record a conversation with the patient and send it to the Consilium",
  "query.chairmanStreaming": "Chairman is composing the response...",
  "query.title": "Ask the Consilium",
  "query.placeholder": "Ask anything... The consilium will deliberate and provide a consensus answer.",
  "query.piiNotice": "PII is automatically redacted",
  "query.submit": "Preguntar al consejo",
  "query.textSize": "Tamaño del texto",
  "query.textSizeDecrease": "Reducir el texto",
  "query.textSizeIncrease": "Aumentar el texto",
  "query.loading": "Consilium is deliberating...",
  "query.consiliumWorking": "Consilium is deliberating...",
  "query.remaining": "remaining",
  "query.almostDone": "Almost done...",
  "query.attachmentWaitNote": "Attached documents take longer — each advisor reads the full file. Please stay on this page.",
  "query.stagePii": "PII screening",
  "query.stageModels": "Models analyzing",
  "query.stageChairman": "Chairman synthesizing",
  "query.stageSaving": "Finalizing",
  "query.success": "Consilium has responded!",
  "query.stage1": "Individual Responses",
  "query.stage3": "Consilium Synthesis",
  "query.chairmanNote": "The Consilium reviewed all responses and compiled this final answer",
  "query.patientMessage": "Patient Message",
  "query.readyToSend": "Ready to review",
  "query.patientMessageNote": "Review and send to the patient. Written in plain language.",
  "query.physicianReview": "Physician Review Summary",
  "query.internalOnly": "Internal",
  "query.tokens": "Tokens",
  "query.yourCost": "Your Cost",
  "query.piiRedacted": "PII entities redacted",
  "query.models": "models",
  "query.emptyTitle": "Ready to consult the Consilium",
  "query.emptyDesc": "Your query will be sent to multiple AI models. They'll analyze and the consilium will synthesize the best answer.",
  "query.addImage": "Photo",
  "query.addFile": "File",
  "query.fileTooLarge": "File too large (max 25MB)",
  "query.tooManyFiles": "Too many files (max {max}).",
  "query.attachmentsTooLarge": "Total attachments too large (max 50MB).",
  "query.unsupportedFile": "Unsupported file type",
  "query.imageTooLarge": "Image too large (max 10MB)",
  "query.timeout": "Query timed out. Please try again.",
  "query.followupTitle": "Follow-up questions to the council",
  "query.followupPlaceholder": "Ask a follow-up question...",
  "query.followupError": "Error sending question",
  "query.followupLimitExceeded": "Follow-up limit reached for this case.",
  "query.followupLimitReached": "You've used all follow-up questions for this case. Start a new case to continue.",
  "query.followupAttachmentsExhausted": "Follow-up attachment limit reached for this case.",
  "query.followupStartNewCase": "Start a new case",
  "query.copied": "Copied",
  "query.copy": "Copy",
  "query.downloadPdf": "Download PDF",
  "query.pdfDownloaded": "PDF downloaded",
  "query.pdfError": "Error downloading PDF",
  "query.pdfNoQuery": "No data to download â run a query first",
  "history.title": "Query History",
  "history.queries": "queries",
  "history.exportCsv": "Export CSV",
  "history.searchPlaceholder": "Search queries...",
  "history.startDate": "Start date",
  "history.endDate": "End date",
  "history.start": "Start",
  "history.end": "End",
  "history.clear": "Clear",
  "history.noQueries": "No queries yet",
  "history.timestamp": "Timestamp",
  "history.queryCol": "Query",
  "history.modelsCol": "Models",
  "history.costCol": "Your Cost",
  "history.piiCol": "PII",
  "history.view": "View",
  "history.queryDetails": "Detalles del caso",
  "history.caseSummary": "Resumen del caso",
  "history.synthesis": "Resumen",
  "history.exported": "History exported!",
  "admin.title": "Admin Panel",
  "admin.dashboard": "Dashboard",
  "admin.auditLog": "Audit Log",
  "admin.team": "Team",
  "admin.settings": "Settings",
  "admin.accessDenied": "Access Denied",
  "admin.noPermission": "You don't have permission to access this page.",
  "dashboard.queriesThisMonth": "Queries this month",
  "dashboard.totalSpend": "Total spend",
  "dashboard.activeUsers": "Active users",
  "dashboard.avgCostPerQuery": "Avg cost/query",
  "dashboard.queriesPerDay": "Queries per Day",
  "dashboard.spendByModel": "Spend by Model",
  "dashboard.topUsers": "Top Users",
  "dashboard.user": "User",
  "dashboard.queries": "Queries",
  "dashboard.spend": "Spend",
  "dashboard.noData": "No data yet",
  "team.title": "Team Members",
  "team.members": "members",
  "team.inviteMembers": "Invite Members",
  "team.inviteTitle": "Invite Team Members",
  "team.inviteDesc": "Add new members to your organization",
  "team.emailAddresses": "Email Addresses",
  "team.emailPlaceholder": "john@example.com, jane@example.com",
  "team.role": "Role",
  "team.member": "Member",
  "team.adminRole": "Admin",
  "team.auditor": "Auditor",
  "team.owner": "Owner",
  "team.cancel": "Cancel",
  "team.sendInvites": "Send Invites",
  "team.joined": "Joined",
  "team.actions": "Actions",
  "team.pendingInvites": "Pending Invites",
  "settings.councilConfig": "Configuración del Consilium",
  "settings.councilConfigDesc": "Configura los especialistas de IA que participan en el consilium",
  "settings.councilMembers": "Miembros del Consilium",
  "settings.chairmanModel": "Modelo del Presidente",
  "settings.personasTitle": "Especialistas",
  "settings.personasDesc": "Activa especialistas, elige su modelo base y define el consejo predeterminado",
  "settings.personaSpecialty": "Especialidad",
  "settings.personaBackingModel": "Modelo base",
  "settings.personaEnabled": "Activado",
  "settings.defaultCouncilMember": "En el consejo predeterminado",
  "settings.chairmanPersona": "Presidente",
  "settings.atLeastOneCouncilMember": "Selecciona al menos un especialista activado para el consejo predeterminado",
  "settings.chairmanMustBeEnabled": "El especialista presidente debe permanecer activado",
  "settings.chairmanRequired": "Se requiere un especialista presidente",
  "settings.personaModelRequired": "Cada especialista seleccionado debe tener un modelo base",
  "settings.councilNotConfigured": "Consejo no configurado",
  "settings.piiRedaction": "PII Redaction",
  "settings.piiRedactionDesc": "Automatically redact sensitive data",
  "settings.saveModelSettings": "Save Model Settings",
  "settings.budgetSettings": "Budget Settings",
  "settings.budgetSettingsDesc": "Control your organization's spending",
  "settings.monthlyLimit": "Monthly Limit (USD)",
  "settings.unlimitedPlaceholder": "Leave empty for unlimited",
  "settings.alertThreshold": "Alert Threshold",
  "settings.currentSpend": "Current spend",
  "settings.saveBudgetSettings": "Save Budget Settings",
  "settings.dangerZone": "Danger Zone",
  "settings.resetMonthlySpend": "Reset Monthly Spend",
  "settings.resetDesc": "Set current month spend to $0.00",
  "settings.reset": "Reset",
  "settings.resetConfirmTitle": "Reset Monthly Spend?",
  "settings.resetConfirmDesc": "This will set the current month spend counter to $0.00. This action cannot be undone.",
  "settings.saving": "Saving...",
  "audit.filterByEmail": "Filter by email...",
  "audit.startDate": "Start",
  "audit.endDate": "End",
  "audit.export": "Export",
  "audit.timestamp": "Timestamp",
  "audit.user": "User",
  "audit.query": "Query",
  "audit.models": "Models",
  "audit.cost": "Cost",
  "audit.noLogs": "No audit logs found",
  "audit.exported": "Audit logs exported!",
  "audit.loadError": "Failed to load audit logs",
  "toast.dashboardError": "Failed to load dashboard",
  "toast.teamError": "Failed to load team",
  "toast.invitesSent": "Invitations sent!",
  "toast.inviteError": "Failed to send invites",
  "toast.roleUpdated": "Role updated",
  "toast.roleError": "Failed to update role",
  "toast.userRemoved": "User removed",
  "toast.userRemoveError": "Failed to remove user",
  "toast.modelsSaved": "Model settings saved!",
  "toast.modelsError": "Failed to save settings",
  "toast.budgetSaved": "Budget settings saved!",
  "toast.budgetError": "Failed to save settings",
  "toast.budgetReset": "Budget spend reset!",
  "toast.budgetResetError": "Failed to reset budget",
  "toast.settingsError": "Failed to load settings",
  "account.title": "Account",
  "account.profile": "Profile",
  "account.organization": "Organization",
  "account.billing": "Billing",
  "account.billingDesc": "Manage your subscription and billing",
  "account.apiKey": "API Key",
  "account.apiKeyDesc": "Use this key to access MedConcil programmatically",
  "account.regenerate": "Regenerate API Key",
  "account.regenerateConfirmTitle": "Regenerate API Key?",
  "account.regenerateConfirmDesc": "Your current API key will be invalidated immediately. Any applications using the old key will stop working.",
  "account.regenerating": "Regenerating...",
  "account.exampleUsage": "Example usage:",
  "account.upgrade": "Upgrade",
  "account.billingComingSoon": "Billing integration coming soon. Contact support to upgrade.",
  "onboarding.createOrg": "Create your organization",
  "onboarding.setupWorkspace": "Set up your workspace",
  "onboarding.configureCouncil": "Configure Consilium",
  "onboarding.selectModels": "Select AI models",
  "onboarding.setBudget": "Set spending limits",
  "onboarding.controlSpending": "Control spending",
  "onboarding.inviteTeam": "Invite your team",
  "onboarding.addCollaborators": "Add collaborators",
  "onboarding.createOrgTitle": "Create your organization",
  "onboarding.createOrgDesc": "This will be your team's workspace",
  "onboarding.orgName": "Organization Name",
  "onboarding.orgNamePlaceholder": "My Clinic",
  "onboarding.workspaceUrl": "Workspace URL",
  "onboarding.createOrgBtn": "Create Organization",
  "onboarding.creating": "Creating...",
  "onboarding.configureCouncilTitle": "Configure your Consilium",
  "onboarding.configureCouncilDesc": "Select which AI models will participate in consensus",
  "onboarding.chairmanNote": "This model synthesizes the final consensus answer",
  "onboarding.back": "Back",
  "onboarding.continue": "Continue",
  "onboarding.setBudgetTitle": "Set spending limits",
  "onboarding.setBudgetDesc": "Control your monthly AI spend",
  "onboarding.budgetNote": "Set a monthly spending cap. Leave empty for no limit.",
  "onboarding.alertNote": "Get notified when spending reaches this percentage of your budget",
  "onboarding.skip": "Skip",
  "onboarding.inviteTeamTitle": "Invite your team",
  "onboarding.inviteTeamDesc": "Add teammates to collaborate",
  "onboarding.separateEmails": "Separate multiple emails with commas",
  "onboarding.defaultRole": "Default Role",
  "onboarding.skipFinish": "Skip & Finish",
  "onboarding.completeSetup": "Complete Setup",
  "onboarding.settingUp": "Setting up...",
  "common.loading": "Loading...",
  "common.error": "Error",
  "common.success": "Success",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.close": "Close",
  "common.back": "Back",
  "common.confirm": "Confirm",
  "common.authError": "Session expired. Please log in again.",
  "common.language": "Idioma",
  "common.english": "English",
  "common.spanish": "Español",
  "common.arabic": "العربية",
  "common.french": "Français",
  "common.russian": "Русский",
  "login.displayNameOptional": "Nombre (opcional)",
  "login.signUpTitle": "Registro",
  "login.signUpWithEmail": "Registrarse con Email",
  "login.signUpDesc": "Sign up to access the clinical council",
  "nav.patients": "Pacientes",
  "nav.platform": "Plataforma",
  "nav.newQuery": "Nueva consulta",
  "query.newQuery": "Nueva consulta",
  "query.filesOnly": "Analice los documentos e imágenes adjuntos.",
  "query.confirmNewQuery": "Query is still processing. Start a new one?",
  "query.confirmNewQueryForce": "Query is still processing. Are you sure you want to start a new one?",
  "reset.invalidLink": "Enlace no válido",
  "reset.tokenMissing": "Falta el token de restablecimiento.",
  "reset.backToLogin": "Volver al inicio de sesión",
  "reset.passwordUpdated": "Contraseña actualizada",
  "reset.canSignIn": "Ya puede iniciar sesión con su nueva contraseña.",
  "reset.signIn": "Iniciar sesión",
  "reset.newPassword": "Nueva contraseña",
  "reset.enterNewPassword": "Ingrese una nueva contraseña para su cuenta",
  "reset.confirmPassword": "Confirmar contraseña",
  "reset.savePassword": "Guardar contraseña",
  "reset.passwordMin": "La contraseña debe tener al menos 6 caracteres",
  "reset.passwordMismatch": "Las contraseñas no coinciden",
  "reset.success": "Contraseña actualizada correctamente",
  "reset.linkInvalid": "El enlace no es válido o ha expirado",
  "reset.failed": "Error al restablecer la contraseña",
  "patients.title": "Historias de pacientes",
  "patients.newPatient": "Nuevo paciente",
  "patients.searchPlaceholder": "Buscar por nombre...",
  "patients.noPatients": "No hay pacientes",
  "patients.name": "Nombre",
  "patients.birthDate": "Fecha de nacimiento",
  "patients.gender": "Sexo",
  "patients.genderMale": "M",
  "patients.genderFemale": "F",
  "patients.actions": "Acciones",
  "patients.open": "Abrir",
  "patients.loadError": "No se pudo cargar la historia",
  "patients.nameRequired": "El nombre es obligatorio",
  "patients.saved": "Paciente guardado",
  "patients.saveError": "Error al guardar",
  "patients.deleted": "Paciente eliminado",
  "patients.deleteError": "Error al eliminar",
  "patients.back": "Volver",
  "patients.edit": "Editar",
  "patients.delete": "Eliminar",
  "patients.newPatientTitle": "Nuevo paciente",
  "patients.editPatientTitle": "Editar paciente",
  "patients.save": "Guardar",
  "patients.saving": "Guardando...",
  "patients.personalInfo": "Datos personales",
  "patients.fullName": "Nombre completo",
  "patients.phone": "Teléfono",
  "patients.email": "Email",
  "patients.medicalProfile": "Perfil médico",
  "patients.bloodType": "Grupo sanguíneo",
  "patients.allergies": "Alergias",
  "patients.diagnoses": "Diagnósticos crónicos",
  "patients.medications": "Medicación actual",
  "patients.surgeries": "Historial quirúrgico",
  "patients.familyHistory": "Antecedentes familiares",
  "patients.notes": "Notas",
  "patients.documents": "Documentos",
  "patients.sessions": "Sesiones de consilium",
  "patients.upload": "Subir",
  "patients.askConsilium": "Consultar al consilium",
  "patients.deleteConfirmTitle": "¿Eliminar paciente?",
  "patients.deleteConfirmDesc": "Esta acción no se puede deshacer.",
  "patients.cancel": "Cancelar",
  "patients.notFound": "Patient not found",
  "patients.genderMaleFull": "Male",
  "patients.genderFemaleFull": "Female",
  "patients.consilium": "Consilium",
  "patients.profile": "Profile",
  "patients.contact": "Contact",
  "patients.snils": "SNILS",
  "patients.snilsPlaceholder": "123-456-789 00",
  "patients.mrn": "MRN",
  "patients.mrnPlaceholder": "12345678",
  "patients.phonePlaceholderUs": "+1 (555) 555-5555",
  "patients.phonePlaceholderCis": "+7...",
  "patients.created": "Created",
  "patients.diagnosis": "Diagnosis",
  "patients.status": "Status",
  "patients.medication": "Medication",
  "patients.dose": "Dose",
  "patients.frequency": "Frequency",
  "patients.patientDocuments": "Patient Documents",
  "patients.titleCol": "Title",
  "patients.category": "Category",
  "patients.date": "Date",
  "patients.size": "Size",
  "patients.noDocuments": "No documents",
  "patients.mode": "Mode",
  "patients.docUploaded": "Document uploaded",
  "patients.uploadError": "Upload error",
  "patients.docDeleted": "Document deleted",
  "patients.add": "Add",
  "patients.searchNamePhone": "Search by name or phone...",
  "patients.search": "Search",
  "patients.birthDateShort": "Birth Date",
  "patients.genderShort": "Sex",
  "patients.noPatientsYet": "No patients yet",
  "patients.noSessionsYet": "No sessions yet",
  "patients.deleteCardTitle": "Delete patient card?",
  "patients.cardUpdated": "Card updated",
  "patients.patientCreated": "Patient created",
  "patients.editCard": "Edit Card",
  "patients.basicInfo": "Basic Info",
  "patients.genderOther": "Other",
  "patients.noAllergies": "No allergies",
  "patients.substance": "Substance",
  "patients.severity": "Severity",
  "patients.severityMild": "Mild",
  "patients.severityModerate": "Moderate",
  "patients.severitySevere": "Severe",
  "patients.reaction": "Reaction",
  "patients.noDiagnoses": "No diagnoses",
  "patients.nameLabel": "Name",
  "patients.icd10": "ICD-10",
  "patients.noMedications": "No medications",
  "patients.noSurgeries": "No surgeries",
  "patients.hospital": "Hospital",
  "patients.familyHistoryHint": "Family history (comma-separated)",
  "patients.additionalNotes": "Additional notes",
  "patients.statusActive": "Active",
  "patients.statusRemission": "Remission",
  "patients.statusResolved": "Resolved",
  "patients.surgery": "Surgery",
  "patients.familyNotes": "Family History & Notes",
  "patients.familyExample": "Diabetes (mother)",
  "patients.additionalNotesPlaceholder": "Additional notes...",
  "onboarding.stepOrg": "Create Organization",
  "onboarding.stepCouncil": "Configure Council",
  "onboarding.stepBudget": "Set Budget",
  "onboarding.stepTeam": "Invite Team",
  "onboarding.slugPlaceholder": "my-clinic",
  "onboarding.orgCreated": "Organization created!",
  "onboarding.fillFields": "Please fill in all fields",
  "onboarding.configCouncil": "Configure your Council",
  "onboarding.configCouncilDesc": "Select AI models for consensus",
  "onboarding.councilMembers": "Council Members",
  "onboarding.chairmanModel": "Chairman Model",
  "onboarding.chairmanModelDesc": "This model synthesizes the final consensus answer",
  "onboarding.monthlyBudget": "Monthly Budget",
  "onboarding.budgetPlaceholder": "Leave empty for unlimited",
  "onboarding.budgetHint": "Set a monthly spending cap. Leave empty for no limit.",
  "onboarding.alertThreshold": "Alert Threshold",
  "onboarding.alertHint": "Get notified when spending reaches this percentage",
  "onboarding.emailAddresses": "Email Addresses",
  "onboarding.emailsHint": "Separate multiple emails with commas",
  "onboarding.roleMember": "Member",
  "onboarding.roleAdmin": "Admin",
  "onboarding.roleAuditor": "Auditor",
  "onboarding.setupComplete": "Setup complete!",
  "onboarding.startBtn": "Get Started",

  // Patient picker / confirm modals
  "patient.phonePlaceholderUs": "+1 (555) 555-5555",
  "patient.phonePlaceholderCis": "+7 916 123-45-67",
  "patient.errPhoneFormatUs": "Formato: +1XXXXXXXXXX",
  "patient.errPhoneFormatCis": "Formato: +7XXXXXXXXXX",
  "query.councilEmptyUsesDefault": "Los médicos se elegirán para su caso.",
  "query.councilAutomatic": "Los médicos se elegirán para su caso.",
  "query.councilGroupGeneralist": "Medicina general",
  "query.councilGroupMedical": "Especialidades médicas",
  "query.councilGroupSurgical": "Especialidades quirúrgicas",
  "query.councilGroupDiagnostic": "Diagnóstico",
  "query.councilSearchPlaceholder": "Buscar por nombre o especialidad",
  "query.councilClearAutomatic": "Borrar (automático)",
  "query.councilSelectedForCase": "Seleccionados para su caso",
  "query.councilExpandSpecialists": "Elegir especialistas",
  "query.councilCollapseSpecialists": "Ocultar especialistas",
  "billing.getMoreCases": "Obtener más casos",
  "billing.viewPlans": "Ver planes",
  "query.b2cSummary": "Resumen",
  "query.b2cNextSteps": "Sus próximos pasos",
  "query.perspectiveLabel": "Asesor de IA · {specialty}",
  "query.perspectiveFallback": "Asesor de IA",
  "query.perspectiveMarker": "AI",
  "query.perspectiveRow": "Perspectivas · AI",
  "query.disclaimerRequired": "Accept the current clinical notice before submitting a case.",
  "healthProfile.units.label": "Unidades",
  "healthProfile.units.metric": "Métrico",
  "healthProfile.units.imperial": "Imperial",
  "healthProfile.heightFt": "Estatura (ft)",
  "healthProfile.heightIn": "Estatura (in)",
  "healthProfile.weightLb": "Peso (lb)",
  "nav.myCases": "Historial médico",
  "history.title": "Historial médico",
  "history.addRecord": "Añadir registro",
  "history.summary": "Resumen",
  "history.timeline": "Cronología",
  "history.uploadDocument": "Subir documento",
  "history.filesSelected": "{count} archivos seleccionados",
  "history.tooManyFiles": "Puede adjuntar hasta {max} archivos a un registro.",
  "history.addEntry": "Añadir entrada",
  "history.category": "Categoría",
  "history.eventDate": "Fecha de la atención",
  "history.datePrecision": "Precisión de la fecha",
  "history.precision.day": "Día",
  "history.precision.month": "Mes",
  "history.precision.year": "Año",
  "history.dateUnknown": "Fecha desconocida",
  "history.titleField": "Título",
  "history.facility": "Centro o clínico",
  "history.notes": "Notas",
  "history.details": "Detalles",
  "history.save": "Guardar",
  "history.cancel": "Cancelar",
  "history.delete": "Eliminar",
  "history.deleteConfirm": "¿Eliminar este registro? No se puede deshacer.",
  "history.deleteCaseDocuments.one": "Eliminar también el documento guardado de este caso",
  "history.deleteCaseDocuments.many": "Eliminar también {n} documentos guardados de este caso",
  "history.attachedFiles.one": "{n} archivo adjunto",
  "history.attachedFiles.many": "{n} archivos adjuntos",
  "history.dateFromCase": "Fecha tomada del caso. Cámbiela si el archivo es anterior.",
  "history.fromCase": "Del caso: {title}",
  "history.fromCaseDated": "De un caso del {date}",
  "history.fromCaseUntitled": "De un caso",
  "history.fromCasePending": "De un caso en curso",
  "history.fromCaseDeleted": "De un caso eliminado",
  "history.filePages": "{n} páginas",
  "history.edit": "Editar",
  "history.download": "Descargar",
  "history.previewUnavailable": "Vista previa no disponible",
  "history.noRecords": "Aún no hay registros",
  "history.noOneOff": "No hay casos puntuales",
  "history.aiSecondOpinion": "Segunda opinión de IA — no es un registro médico",
  "history.recordCount": "{count} registros",
  "history.storageUsage": "{used} MB de {limit} MB usados",
  "history.conditions": "Condiciones",
  "history.medications": "Medicamentos",
  "history.allergies": "Alergias",
  "history.noneReported": "Ninguna informada",
  "history.notProvided": "Aún no añadido",
  "history.review": "Revisar",
  "history.latest": "Más reciente",
  "history.consentTitle": "Guardar registros de salud",
  "history.consentAccept": "Acepto",
  "history.consentRequired": "Acepte el consentimiento de almacenamiento antes de añadir un registro.",
  "history.duplicateWarning": "Ya hay un archivo con el mismo contenido. Se conservaron ambas copias.",
  "history.storageFull": "El almacenamiento del historial está lleno. Quite un archivo grande e inténtelo de nuevo.",
  "history.caseFilesNotSavedTitle": "Los archivos no se guardaron",
  "history.caseFilesNotSaved": "Estos archivos no se guardaron en el historial médico. Añádalos más tarde desde Historial médico.",
  "history.caseFilesNotSavedOk": "OK",
  "history.shareSessionExpired": "Su sesión de visualización terminó. Introduzca de nuevo el código de acceso.",
  "history.saved": "Registro guardado",
  "history.saveError": "No se pudo guardar el registro",
  "history.loadError": "No se pudo cargar el historial médico",
  "history.deleted": "Registro eliminado",
  "history.saveFilesToHistory": "Guardar estos archivos en el historial médico de {name}",
  "history.oneOffCases": "Casos puntuales",
  "history.tierA": "Edad y sexo al nacer",
  "history.fileUnavailable": "El archivo ya no está disponible",
  "history.updated": "Actualizado {date}",
  "history.source.user_upload": "Subido por usted",
  "history.source.user_entered": "Introducido por usted",
  "history.source.case_attachment": "Guardado desde un caso",
  "history.source.medconcil_case": "Caso de MedConcil",
  "history.category.visit_note": "Nota de visita",
  "history.category.discharge_summary": "Informe de alta",
  "history.category.lab_result": "Resultado de laboratorio",
  "history.category.imaging_report": "Informe de imagen",
  "history.category.prescription": "Receta",
  "history.category.procedure": "Procedimiento",
  "history.category.immunization": "Vacuna",
  "history.category.referral": "Derivación",
  "history.category.other": "Otro",
  "history.category.ai_second_opinion": "Segunda opinión de IA",
  "history.export": "Exportar",
  "history.exportTitle": "Exportar historial médico",
  "history.exportDescription": "Un resumen clínico para un médico. MedConcil no verifica estos registros.",
  "history.exportFormat": "Formato",
  "history.format.pdf": "Resumen PDF",
  "history.format.fhir": "Resumen internacional del paciente FHIR (JSON)",
  "history.format.zip": "ZIP con PDF, FHIR y documentos",
  "history.includeAiOpinions": "Incluir segundas opiniones de IA",
  "history.exportAiHint": "Las segundas opiniones de IA quedan fuera salvo que marque esto.",
  "history.exportWholeHistory": "Historial completo",
  "history.exportChooseRecords": "Elegir registros",
  "history.pickerTruncated": "Se muestran los {n} registros más recientes. Los registros más antiguos de este período están incluidos.",
  "history.exportIdentityTitle": "Nombre legal y fecha de nacimiento",
  "history.exportIdentityHelp": "Las clínicas los necesitan en el resumen. Guárdelos para la próxima vez o úselos una sola vez. Si deja el nombre en blanco, el documento dirá “Name not provided”.",
  "history.exportLegalName": "Nombre legal",
  "history.exportDateOfBirth": "Fecha de nacimiento",
  "history.exportSaveIdentity": "Guardar para próximas exportaciones",
  "history.exportUseSaved": "Usar el nombre y la fecha de nacimiento guardados",
  "history.exportChangeIdentity": "Introducir otro nombre o fecha de nacimiento",
  "history.exportDownload": "Descargar",
  "history.exportWorking": "Preparando la exportación…",
  "history.exportDone": "Exportación descargada",
  "history.exportError": "No se pudo exportar el historial médico",
  "history.exportTooLarge": "Esta exportación es demasiado grande. Desactive los documentos o seleccione menos registros e inténtelo de nuevo.",
  "history.shareDoctorNote": "Nota para el médico",
  "history.exportIdentityInvalid": "Introduzca una fecha de nacimiento real o déjela en blanco.",
  "history.share": "Compartir",
  "history.shareTitle": "Compartir con un médico",
  "history.shareDescription": "Un enlace por tiempo limitado. Puede detenerlo. Las copias ya descargadas se quedan con quien las recibió.",
  "history.shareExpires": "El enlace caduca",
  "history.shareExpires.1h": "1 hora",
  "history.shareExpires.24h": "24 horas",
  "history.shareExpires.7d": "7 días",
  "history.shareExpires.30d": "30 días",
  "history.shareRequireCode": "Pedir un código de 6 dígitos",
  "history.shareNotify": "Enviarme un correo cuando abran el enlace por primera vez",
  "history.shareConsentAccept": "Acepto enviar estos registros",
  "history.shareCreate": "Crear enlace",
  "history.shareWorking": "Creando el enlace…",
  "history.shareCodeOnce": "Copie el enlace y el código ahora. No se pueden volver a mostrar.",
  "history.shareUrl": "Enlace",
  "history.shareCode": "Código de acceso",
  "history.shareCopy": "Copiar enlace",
  "history.shareCopyCode": "Copiar código",
  "history.shareCodeCopied": "Código copiado",
  "history.shareCopied": "Enlace copiado",
  "history.shareDone": "Listo",
  "history.shareError": "No se pudo actualizar el uso compartido",
  "history.shareConsentRequired": "Acepte el consentimiento para compartir antes de crear un enlace.",
  "history.shareLimit": "Esta persona ya tiene el máximo de enlaces activos.",
  "history.shareWholeHistory": "Historial completo",
  "history.shareChooseRecords": "Elegir registros",
  "history.shareIncludeSummary": "Incluir el resumen",
  "history.sharePersonFallback": "esta persona",
  "history.sharesTitle": "Enlaces compartidos",
  "history.noActiveShares": "No hay enlaces activos",
  "history.shareStop": "Dejar de compartir",
  "history.shareStopped": "Enlace detenido",
  "history.shareOpens": "Abierto {count} veces",
  "history.shareExpiresAt": "Caduca {date}",
  "history.shareCreatedAt": "Creado {date}",
  "history.shareScopeSummary": "Resumen",
  "history.shareScopeRecords": "{count} registros",
  "history.shareScopeAi": "Incluye opiniones de IA",
  "history.downloadPacket": "Descargar",
  "history.shareWithDoctor": "Compartir con un médico",
  "history.packetTitle": "Preparar para un médico",
  "history.packetDescription": "Elija lo que debe ver este médico y luego descargue un archivo o cree un enlace.",
  "history.packetStepInclude": "Qué incluir",
  "history.packetStepSend": "Cómo enviarlo",
  "history.scopeProfile": "Resumen del perfil (alergias, medicamentos, afecciones, estilo de vida)",
  "history.scopeIdentity": "Nombre legal y fecha de nacimiento",
  "history.scopeDocuments": "Adjuntar los documentos originales",
  "history.scopeNote": "Nota para el médico",
  "history.scopeNotePlaceholder": "Opcional. Hasta 1000 caracteres.",
  "history.scopePeriodWhole": "Período: historial completo",
  "history.scopePreview": "{records} registros · {documents} documentos ({size}) · {consultations} consultas",
  "history.scopePreviewLoading": "Contando registros…",
  "history.packetSaveIdentity": "Guardado para próximos paquetes",
  "history.packetSaveRequired": "Un enlace con nombre o fecha de nacimiento los guarda para los próximos paquetes.",
  "history.packetIdentityOmitted": "Este enlace no incluirá el nombre ni la fecha de nacimiento.",
  "history.chooseOneItem": "Elija al menos un elemento.",
  "history.profileAsOf": "Perfil actualizado a {date}",
  "history.pregnancy": "Embarazo",
  "history.activeProblems": "Problemas activos",
  "history.vitals": "Constantes y estilo de vida",
  "history.height": "Estatura",
  "history.weight": "Peso",
  "history.bmi": "IMC",
  "history.smoking": "Tabaco",
  "history.alcohol": "Alcohol",
  "history.activity": "Actividad",
  "history.sleep": "Sueño",
  "history.surgeries": "Procedimientos y cirugías",
  "history.scopeError.empty": "Elija al menos un elemento.",
  "history.scopeError.outside_period": "Uno o más registros están fuera del período elegido.",
  "history.scopeError.not_found": "No se encontró uno o más registros.",
  "history.scopeError.invalid_period": "Ese período no es válido.",
  "history.scopeError.note_too_long": "La nota para el médico debe tener 1000 caracteres o menos.",
  "history.scopeError.ambiguous_shape": "Elija los registros de una sola manera.",
  "history.shareScopeProfile": "perfil",
  "history.shareScopeIdentity": "identidad",
  "history.shareScopeDocuments": "documentos",
  "history.shareScopeAiShort": "IA",
  "history.shareScopePeriod.whole": "Historial completo",
  "history.shareScopePeriod.12m": "Últimos 12 meses",
  "history.shareScopePeriod.3y": "Últimos 3 años",
  "history.shareScopePeriod.5y": "Últimos 5 años",
  "history.shareScopePeriod.custom": "Período personalizado",
  "history.shareScopePeriodRange": "{label} ({from} – {to})",
  "history.period.12m": "Últimos 12 meses",
  "history.period.3y": "Últimos 3 años",
  "history.period.5y": "Últimos 5 años",
  "history.period.all": "Historial completo",
  "history.period.custom": "Personalizado",
  "history.periodChip": "{label} ({count})",
  "history.periodFrom": "Desde",
  "history.periodTo": "Hasta",
  "history.periodUndated": "Incluir registros sin fecha ({count})",
  "history.periodInvalid": "Indique una fecha de inicio anterior o igual a la de fin.",
  "history.shareLog": "Registro de acceso",
  "history.shareLogEmpty": "Aún no se ha abierto",
  "history.shareEvent.unlocked": "Abierto",
  "history.shareEvent.file_downloaded": "Archivo descargado",
  "history.shareEvent.exported": "Exportado",
  "history.shareClient.chrome": "Chrome",
  "history.shareClient.firefox": "Firefox",
  "history.shareClient.safari": "Safari",
  "history.shareClient.edge": "Edge",
  "history.shareClient.other": "Otro navegador",
  "history.shareBanner": "Compartido por el paciente o quien lo cuida. MedConcil no lo ha verificado. Las opiniones de IA están etiquetadas y no son diagnósticos.",
  "history.shareCodePrompt": "Introduzca el código de acceso",
  "history.shareCodeLabel": "Código de acceso",
  "history.shareCodeContinue": "Continuar",
  "history.shareCodeOptional": "Si no le dieron un código, continúe.",
  "history.shareInvalidCode": "Ese código no es válido.",
  "history.shareLocked": "Demasiados intentos. Inténtelo más tarde.",
  "history.shareNotFound": "Este enlace no está disponible.",
  "history.shareDownloadPdf": "Descargar PDF",
  "history.shareDownloadFhir": "Descargar FHIR",
  "history.shareDownloadZip": "Descargar ZIP",
  "history.shareLoading": "Cargando…",
  "history.shareViewFile": "Documento",
  "history.shareCloseFile": "Cerrar",
};
